import { createContext } from 'react';

import type { InFieldUserResponse } from '@cognite/apm-client';
import { useAuthContext } from '@cognite/e2e-auth';
import { Metrics } from '@cognite/metrics';

import { useUserServices } from '../cdm-use-user-services';
import { useRegisterCurrentUser } from '../use-mutation/cdm-use-register-user-mutation';

export interface UseCurrentUserQueryContextInterface {
  useAuthContext: () => {
    authState: {
      user: {
        cdfId: string;
        name: string;
        email: string;
      };
      projectInfo: {
        id: string;
      };
    };
  };
  useUserServices: () => {
    userService: {
      getCurrentUser: (cdfId: string) => Promise<InFieldUserResponse | null>;
    };
  };
  useRegisterCurrentUser: () => {
    mutateAsync: ReturnType<typeof useRegisterCurrentUser>['mutateAsync'];
    error: ReturnType<typeof useRegisterCurrentUser>['error'];
    isError: ReturnType<typeof useRegisterCurrentUser>['isError'];
  };
  Metrics: {
    register: (typeof Metrics)['register'];
  };
}

const defaultValue: UseCurrentUserQueryContextInterface = {
  useAuthContext,
  useUserServices,
  useRegisterCurrentUser,
  Metrics,
};

export const UseCurrentUserQueryContext =
  createContext<UseCurrentUserQueryContextInterface>(defaultValue);
